export const slider = ['$timeout', ($timeout)=>{
  return {
    link(scope, elem, attrs) {
      scope.active = 0
      const delay = attrs.sliderDelay || 5000
      scope.autoplay = () => {
        scope.active < elem.context.children.length - 1 ? scope.active++ : scope.active = 0
        $timeout(scope.autoplay, delay)
      }
      $timeout(scope.autoplay, delay)
    }
  }
}]